export default "__VITE_PUBLIC_ASSET__cc55fd4a__"